import { Link } from "react-router-dom";

import { InfoText } from "../../../common/components/info_text";
import { FormStepCard } from "../../../common/components/form_steps";

import { textChooser } from "../../../common/util/textChooser";

import { RegisterFormContainer } from "./styled";

export const SuccessScreen = () => {
  return (
    <FormStepCard title={textChooser("txt49")} showBackButton={false}>
      <RegisterFormContainer>
        <InfoText
          text={textChooser("txt53")}
          type="plain"
          medium
        />


        <Link className="submit-link" to="/login">
          <InfoText
            text={textChooser("txt1")}
            type="info"
            medium
            bold
          />
        </Link>

      </RegisterFormContainer>
    </FormStepCard>
  )
}